// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";
import CustomerDetails from '../components/DealerManagement/Admin/OnBoardManagement/Onboard/CustomerDetails'
//import AddNewAgent from "../components/DealerManagement/Admin/OnBoardManagement/OnBoardManagement/OnBoard/AgentForm";
import AddNewCustomer from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/CustomerForm";
import Dashboard from "../components/DealerManagement/Dashboard";
import Onboard from "../components/DealerManagement/Admin/OnBoardManagement/Onboard";
import BussinessPartner from "../components/DealerManagement/Admin/DealerManagement/BusinessPartner/BussinessPartnerList";

import ROUTES_NAVIGATION from "./routes";
import AddNewAgent from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/AgentForm";
import OnboardApproval from "../components/DealerManagement/Admin/OnBoardManagement/OnboardApproval";
import EditNewAgent from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/EditAgentForm";
import AgentDetails from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/AgentDetails";
import CustomerConfigUploadForm from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/CustomerConfigUploadForm";
import LeadUpload from "../components/DealerManagement/Admin/BulkUpload";
import BulkUpload from "../components/DealerManagement/Admin/BulkUpload/BulkUpload";
import EditAgentCustomerForm from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/EditAgentCustomerForm.js";
import ProtectedRoute from "./ProtectedRoute.js";
import ForgotPassword from "../components/DealerAdminDashboard/ForgotPassword/index.js";
import MISreport from "../components/DealerManagement/Admin/MISReport/index.js";
import AdminCustomerPurchaseOrder from "../components/DealerManagement/Admin/OrderManagement/CustomerPurchaseOrder/index.js";
import AdminWarrantyCheck from "../components/DealerManagement/Admin/WarrantyManagement/WarrantyCheck/index.js";
import Engineer from "../components/DealerManagement/Admin/Engineer/index.js";
import AddEngineer from "../components/DealerManagement/Admin/Engineer/AddEngineer/index.js";
import EditEngineer from "../components/DealerManagement/Admin/Engineer/EditEngineer/index.js";
import WarrantyCheckDetailsAdmin from "../components/DealerManagement/Admin/WarrantyManagement/WarrantyCheck/WarrantyCheckDetails/index.js";
import DealerLoginReport from "../components/DealerManagement/Admin/DealerLoginReport/index.js";
import ViewProfileDealer from "../components/DealerManagement/Admin/DealerManagement/Dealer/ViewProfileDealer/index.js";
import SalesPersonList from "../components/DealerManagement/Admin/SalesPerson/SalesPersonList/index.js";
import AddSalesPerson from "../components/DealerManagement/Admin/SalesPerson/AddSalesPerson/index.js";
import EditSalesPerson from "../components/DealerManagement/Admin/SalesPerson/EditSalesPerson/index.js";
import GracePeriodListAdmin from "../components/DealerManagement/Admin/GraceListAdmin/index.js";
// import BulkUpload from "../components/DealerManagement/Admin/BulkUpload";
import AdminSalesReport from "../components/DealerManagement/Admin/MISReport/AdminSalesReport/index.js";
import AdminStockReport from "../components/DealerManagement/Admin/MISReport/AdminStockReport/index.js";
import AdminWarrantyReport from "../components/DealerManagement/Admin/MISReport/AdminWarrantyReport/index.js";
import AdminJobCard from "../components/DealerManagement/Admin/MISReport/AdminJobCard/index.js";
import AdminRiderDetails from "../components/DealerManagement/Admin/MISReport/AdminRiderDetails/index.js";
import MisReportClaim from "../components/DealerManagement/Admin/MISReport/MisReportClaim/index.js";
import AdminDiscountReport from "../components/DealerManagement/Admin/MISReport/AdminDiscountReport/index.js";
import AdminOrderDetailsReport from "../components/DealerManagement/Admin/MISReport/OrderDetailsReport/index.js";
import DealerVehicleReport from "../components/DealerManagement/Admin/MISReport/DealerVehicleReport/index.js";
import SoldCustomerPurchaseOrder from "../components/DealerManagement/Sales/InstockSoldVehicle/index.js";
import SoldAddPurchaseOrder from "../components/DealerManagement/Sales/InstockSoldVehicle/SoldAddPurchaseOrder/index.js";



const CardRoutes = () => {
  return (
    <>
    
      <Route path={ROUTES_NAVIGATION.AGENTDETAILS} element={<AgentDetails />} />
      <Route path={ROUTES_NAVIGATION.ADDNEWAGENT} element={<AddNewAgent />} />
      {/* <Route path={ROUTES_NAVIGATION.AGENTDETAILS} element={<AgentDetails/> } /> */}
      <Route path={ROUTES_NAVIGATION.EDITAGENT} element={ <EditNewAgent/> } />
      <Route path={ROUTES_NAVIGATION.EDITCUSTOMERAGENTFORM} element={ <EditAgentCustomerForm/> }  />
      <Route path={ROUTES_NAVIGATION.ADDNEWCUSTOMER} element={<AddNewCustomer />} />
      <Route path={ROUTES_NAVIGATION.CARDDASHBOARD} element={<ProtectedRoute component={Dashboard} />} />
      <Route path={ROUTES_NAVIGATION.CARDDASHBOARDADMIN}  element={<ProtectedRoute component={Dashboard} />} />
      <Route path={ROUTES_NAVIGATION.CUSTOMERDETAILS} element={<CustomerDetails />} />
      <Route path={ROUTES_NAVIGATION.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTES_NAVIGATION.ONBOARD} element={<Onboard />} />
      <Route path={ROUTES_NAVIGATION.ONBOARDAPPROVAL} element={<OnboardApproval />} />
      <Route path={ROUTES_NAVIGATION.ADMINSALESREPORT} element={<AdminSalesReport/>}/>
      <Route path={ROUTES_NAVIGATION.ADMINSTOCKREPORT} element={<AdminStockReport/>}/>
      <Route path={ROUTES_NAVIGATION.ADMINWARRANTYREPORT} element={<AdminWarrantyReport/>}/>
      <Route path ={ROUTES_NAVIGATION.ADMINRIDERSALES} element={<AdminRiderDetails/>}/>
      <Route path={ROUTES_NAVIGATION.ADMINJOBCARD} element={<AdminJobCard/>}/>

      {/* <Route path={ROUTES_NAVIGATION.CUSTOMERUPDATIONFORM + "/:MQ=="} element={<CustomerConfigUploadForm/> }  /> */}

      <Route path={ROUTES_NAVIGATION.LEADUPLOAD} element={<LeadUpload/> } />
      <Route path={ROUTES_NAVIGATION.BULKUPLOAD} element={ <BulkUpload/> } />

      <Route path={ROUTES_NAVIGATION.ENGINEER} element={<Engineer/>  } />
      <Route path={ROUTES_NAVIGATION.ADDENGINEER} element={<AddEngineer/>  } />
      <Route path={ROUTES_NAVIGATION.EDITENGINEER} element={<EditEngineer/>  } />
      <Route path={ROUTES_NAVIGATION.VIEWPROFILEDEALER} element={<ViewProfileDealer/>  } />
      <Route path={ROUTES_NAVIGATION.SALESPERSON} element={<SalesPersonList/>  } />
      <Route path={ROUTES_NAVIGATION.ADDSALESPERSON} element={<AddSalesPerson/>  } />
      <Route path={ROUTES_NAVIGATION.EDITSALESPERSON} element={<EditSalesPerson/>  } />

      <Route path={ROUTES_NAVIGATION.ADMINGRACEPERIOD} element={<GracePeriodListAdmin/>  } />

      <Route path={ROUTES_NAVIGATION.ONBOARDAPPROVAL} element={<Dashboard />} />
     
      <Route path="admin/manage-onboard/onboard-approval" element={<Dashboard />} />

      <Route path={ROUTES_NAVIGATION.ADMINMISREPORTSALES} element={ <MISreport/>  } />

      <Route path={ROUTES_NAVIGATION.MISREPORTCLAIM} element={ <MisReportClaim/>  } />

      <Route path={ROUTES_NAVIGATION.ADMINCUSTOMERPURCHASEORDER} element={ <AdminCustomerPurchaseOrder/> } />
      <Route path={ROUTES_NAVIGATION.DEALERLOGINREPORT} element={<DealerLoginReport/>}/>

      <Route path={ROUTES_NAVIGATION.DISCOUNTREPORT} element={<AdminDiscountReport/>}/>

      <Route path={ROUTES_NAVIGATION.ADMINWARRANTYCHECK} element={ <AdminWarrantyCheck/> } />
      <Route path={ROUTES_NAVIGATION.ADMINWARRANTYCHECKDETAILS} element={ <WarrantyCheckDetailsAdmin/> } />

      <Route path={ROUTES_NAVIGATION.ORDERDETAILS} element={ <AdminOrderDetailsReport/> } />
      <Route path={ROUTES_NAVIGATION.STOCKDETAILSVEHICLES} element={<DealerVehicleReport/>  } />
       <Route 
      path={ROUTES_NAVIGATION.SOLDVEHICLECUSTOMERSTOCKIN}
      element={ <SoldCustomerPurchaseOrder/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDSOLDVEHICLESERIALS}
      element={ <SoldAddPurchaseOrder/> }
      />

      {/* <Route path={ROUTES_NAVIGATION.FORGOTPASSWORD}  element={ <ForgotPassword/> } /> */}
      {/* <Route path={ROUTES_NAVIGATION.BUSSINESSPARTNER} element={<BussinessPartner />} /> */}
      
     
      {/* <Route path="admin/manage-product/product" element={<ProduuctComponent />}>
        <Route path="" element={<ProductList />} />
        <Route path="create" element={<Product />} />
        <Route path="list" element={<ProductList />} />
      </Route> */}
    </>
  );
};

export default CardRoutes;
